import type { IconProps } from '../types/IconProps.ts';
export const CircleUser: IconProps = {
    name: 'CircleUser',
    children: [
        `<path d="M12 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8M18 20c0-2.76-2.69-5-6-5s-6 2.24-6 5" />`,
        `<circle cx="12" cy="12" r="10" />`,
    ]
};